export function Footer() {
    return (
        <footer className="footer">
            <div className="container footer__inner">
                <div className="footer__text">
                    <span style={{ fontWeight: 700 }}>
                        Bit<span className="text-accent">Fund</span>
                    </span>{' '}
                    &mdash; Crowdfunding on Bitcoin L1. Powered by{' '}
                    <a href="https://opnet.org" target="_blank" rel="noopener noreferrer">
                        OPNet
                    </a>
                    .
                </div>
                <div className="footer__links">
                    <a
                        href="https://github.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer__link"
                    >
                        GitHub
                    </a>
                    <a
                        href="https://twitter.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer__link"
                    >
                        Twitter
                    </a>
                    <a
                        href="https://vibecode.finance"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer__link"
                    >
                        Vibecode
                    </a>
                </div>
            </div>
        </footer>
    );
}
